import { FC, useState } from 'react';

import { logger } from '@belong/logging/logger';
import { applyDictionary } from '@belong/type-utils';

import ChatAPI from '../../api';
import { LIVE_CHAT_TEST_IDS } from '../../lib/testIds';
import { PlainButton, Star, StarSelected, StarWrapper, Title } from './ChatFeedback.styles';
import CONTENT from '../content.json';

type FeedbackStarsProps = {
  onSuccess: () => void;
  contactId?: string;
};

export const FeedbackStars: FC<FeedbackStarsProps> = ({ contactId, onSuccess }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  const handleClick = (value: number) => {
    if (!contactId) {
      return;
    }

    setRating(value);
    ChatAPI.sendRating(contactId, value)
      .then(response => {
        if (!response.ok) {
          throw new Error(`${response.status} ${response.statusText}`);
        } else {
          onSuccess();
        }
      })
      .catch(error => {
        logger.error(`Failed to submit chat feedback rating: ${error.message}`);
      });
  };

  return (
    <>
      <Title id={LIVE_CHAT_TEST_IDS.FEEDBACK_TITLE} aria-live="polite">
        {CONTENT.feedback.rating.question}
      </Title>
      <StarWrapper role="group" aria-labelledby={LIVE_CHAT_TEST_IDS.FEEDBACK_TITLE}>
        {[1, 2, 3, 4, 5].map(value => (
          <PlainButton
            key={value}
            onClick={() => handleClick(value)}
            onMouseEnter={() => setHover(value)}
            onMouseLeave={() => setHover(rating)}
            aria-label={applyDictionary({ value }, CONTENT.ariaLabels.feedbackStar)}
            data-testid={LIVE_CHAT_TEST_IDS.RATING_BUTTON}
          >
            {value <= (hover || rating) ? <StarSelected /> : <Star />}
          </PlainButton>
        ))}
      </StarWrapper>
    </>
  );
};
